import { render, staticRenderFns } from "./AnexarSubunidad.vue?vue&type=template&id=8d1b7fa0"
import script from "./AnexarSubunidad.vue?vue&type=script&lang=js"
export * from "./AnexarSubunidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d1b7fa0')) {
      api.createRecord('8d1b7fa0', component.options)
    } else {
      api.reload('8d1b7fa0', component.options)
    }
    module.hot.accept("./AnexarSubunidad.vue?vue&type=template&id=8d1b7fa0", function () {
      api.rerender('8d1b7fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/acciones/AnexarSubunidad.vue"
export default component.exports